import { render } from "./EventSettingTabs.vue?vue&type=template&id=5fcee9a8&scoped=true&ts=true"
import script from "./EventSettingTabs.vue?vue&type=script&lang=ts"
export * from "./EventSettingTabs.vue?vue&type=script&lang=ts"

import "./EventSettingTabs.vue?vue&type=style&index=0&id=5fcee9a8&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fcee9a8"]])

export default __exports__